/* ══════════════════════════════════════════════════════════════
   Locales Barrel Export — Registers all 8 languages
   ══════════════════════════════════════════════════════════════ */

import { registerLocale } from '../utils/i18n';
import { en } from './en';
import { hi } from './hi';
import { ta } from './ta';
import { te } from './te';
import { mr } from './mr';
import { bn } from './bn';
import { gu } from './gu';
import { kn } from './kn';

/** Call once at app boot to register all locale data */
export function registerAllLocales(): void {
    registerLocale('en', en);
    registerLocale('hi', hi);
    registerLocale('ta', ta);
    registerLocale('te', te);
    registerLocale('mr', mr);
    registerLocale('bn', bn);
    registerLocale('gu', gu);
    registerLocale('kn', kn);
}

export { en, hi, ta, te, mr, bn, gu, kn };
